import { z } from 'zod';

/**
 * An invoice is the record of a document produced outside the app, tied to the exact order charges it covers
 * (`invoice_charges`). Its discount posts when it is recorded, its payment when it is marked paid; voiding reverses
 * both and frees the charges. `stripe_invoice_id` is null until Stripe Invoicing is attached.
 */
export const invoiceStatusSchema = z.enum(['issued', 'paid', 'void']);
export type InvoiceStatus = z.infer<typeof invoiceStatusSchema>;

const day = z.iso.date();

/** A row of `public.invoices`, as staff read it (`staff.ledger.view`). */
export const invoiceSchema = z.object({
  id: z.uuid(),
  organization_id: z.uuid(),
  external_ref: z.string().min(1).max(80),
  issued_on: day,
  amount_cents: z.number().int().positive(),
  discount_cents: z.number().int().nonnegative(),
  currency: z.enum(['USD', 'CAD']),
  status: invoiceStatusSchema,
  paid_on: day.nullable(),
  void_memo: z.string().nullable(),
  voided_at: z.iso.datetime({ offset: true }).nullable(),
  voided_by: z.uuid().nullable(),
  stripe_invoice_id: z.string().nullable(),
  created_by: z.uuid().nullable(),
  created_at: z.iso.datetime({ offset: true }),
});
export type Invoice = z.infer<typeof invoiceSchema>;
